import React from 'react';
import Text from './base';

const Title = ({ responsive, ...props }) => (
  <Text
    defaultTag="h1"
    variant={responsive ? 'responsiveTitle' : 'title'}
    {...props}
  />
);

export default Title;
